// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__3i8Rq","header":"styles_header__2acUm","back":"styles_back__1QVBm","title":"styles_title__1MYNC","content":"styles_content__2ccUb"};